<p *ngFor="let paragraph of paragraphs$ | async; let last = last" [class.mb-2]="!last">{{ paragraph }}</p>
